import { ShieldX, ShieldCheck, Unlock, MapPin, Smartphone, User } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { fmtDateTime } from "@/lib/format";
import { cn } from "@/lib/utils";

// Engellenen bağlantılar (aktif + geçmiş) — yönetici engeli kaldırır
export function BanList({ bans, onUnban, busy, showHistory = true }) {
  const list = (bans || []).filter((b) => showHistory || b.active);
  if (!list.length) return <p className="text-sm text-muted-foreground py-3" data-testid="ban-list-empty">Engellenen bağlantı yok.</p>;
  return (
    <div className="space-y-2" data-testid="ban-list">
      {list.map((b) => {
        const g = b.geo || {};
        return (
          <div key={b.id} className={cn("rounded-xl border p-3 flex flex-col sm:flex-row sm:items-center gap-3", b.active ? "border-red-300 bg-red-50/60 dark:bg-red-500/10" : "bg-muted/30")} data-testid={`ban-${b.id}`}>
            <div className={cn("h-10 w-10 rounded-lg grid place-items-center shrink-0", b.active ? "bg-red-600 text-white" : "bg-muted text-muted-foreground")}>{b.active ? <ShieldX className="h-5 w-5" /> : <ShieldCheck className="h-5 w-5" />}</div>
            <div className="min-w-0 flex-1 text-sm">
              <div className="flex items-center gap-2 flex-wrap">
                <b className="font-mono">{b.ip}</b>
                <Badge variant="outline" className="text-[10px] py-0">{b.kind === "device" ? `Cihaz ${String(b.device_id || "").slice(0, 8)}` : "IP engeli"}</Badge>
                {b.active ? <Badge className="bg-red-600 hover:bg-red-600 text-[10px] py-0">AKTİF</Badge> : <Badge variant="secondary" className="text-[10px] py-0">Kaldırıldı</Badge>}
              </div>
              <div className="text-xs text-muted-foreground mt-1 flex flex-wrap gap-x-3 gap-y-0.5">
                <span>{b.reason}</span>
                {b.user_name && <span className="inline-flex items-center gap-1"><User className="h-3 w-3" />{b.user_name}</span>}
                {(g.city || g.isp) && <span className="inline-flex items-center gap-1"><MapPin className="h-3 w-3" />{[g.city, g.country].filter(Boolean).join(", ")}{g.isp ? ` · ${g.isp}` : ""}</span>}
                {b.ua_summary && <span className="inline-flex items-center gap-1"><Smartphone className="h-3 w-3" />{b.ua_summary}</span>}
              </div>
              <div className="text-[11px] text-muted-foreground mt-0.5">{fmtDateTime(b.created_at)}{!b.active && b.unbanned_at ? ` · ${b.unbanned_by} kaldırdı (${fmtDateTime(b.unbanned_at)})` : ""}</div>
            </div>
            {b.active && <Button size="sm" variant="outline" className="border-red-300 text-red-700 hover:bg-red-100 shrink-0" disabled={busy === b.id} onClick={() => onUnban(b)} data-testid={`ban-unban-${b.id}`}><Unlock className="h-4 w-4 mr-1.5" />Engeli Kaldır</Button>}
          </div>
        );
      })}
    </div>
  );
}
